import React from 'react'
import HomeAbout from '../components/HomeAbout'
import TgLink from '../components/TgLink'
import HeaderNav from '../components/HeaderNav'
// import Otziv from '../components/Otziv'
import { Helmet } from 'react-helmet'

export default function About() {
  return (
    <div className='About'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Мебель ташкент | о нас </title>
          <meta
            name="description"
            content="Широкий выбор мебели для дома, офиса и интерьера. Уникальный дизайн, доступные цены и доставка по Ташкенту. Оформите заказ онлайн уже сегодня!"
          />
          <meta name="keywords" content="мебель на заказ в ташкенте, мебель на заказ в ташкенте цены, заказать мебель в Ташкенте, купить диван в ташкенте"/>
          <meta property="og:title" content="О нас"/>
          <meta property="og:url" content="https://arzon-mebellar.uz/about/"></meta>
          <meta property="og:description" content="Широкий выбор мебели для дома, офиса и интерьера. Уникальный дизайн, доступные цены и доставка по Ташкенту. Оформите заказ онлайн уже сегодня!"/>
          <meta property="og:site_name" content="Arzon Mebellar"/>
          <meta property="og:image" content="../assets/images/1.jpg"/>
          <link rel="canonical" href="https://arzon-mebellar.uz/about" />
          
      </Helmet>
      <HeaderNav/>
      <HomeAbout/>
      <TgLink/>
      {/* <Otziv/> */}
    </div>
  )
}
